import React from "../../__compat__/react/main.entry.mjs.mjs";
import { GenericNavigationList } from "../GenericNavigation/index.mjs.mjs";
import { Tab } from "./Tab.mjs.mjs";
export const TabGroup = React.forwardRef((props, ref) => (React.createElement(GenericNavigationList, { ...props, ref: ref, variant: "tabs", itemType: Tab })));
TabGroup.displayName = 'TabGroup';
//# sourceMappingURL=TabGroup.mjs.mjs.map